module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticClass: "om61InventoryTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.om61InventorySettings
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
      "min-width": "10%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.denomination.toFixed(2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.numberOfRecyclers'),
      "min-width": "8%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "filterable": "",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.recyclersUpdated(scope.row)
            }
          },
          model: {
            value: (scope.row.numberOfRecyclers),
            callback: function($$v) {
              _vm.$set(scope.row, "numberOfRecyclers", $$v)
            },
            expression: "scope.row.numberOfRecyclers"
          }
        }, _vm._l(((_vm.maxNumberOfRecyclers + 1)), function(value, index) {
          return _c('el-option', {
            attrs: {
              "value": index
            },
            nativeOn: {
              "click": function($event) {
                _vm.forceUpdate()
              }
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.min'),
      "min-width": "8%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.minAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "minAmount", $$v)
            },
            expression: "scope.row.minAmount"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.optimum'),
      "min-width": "8%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.optimumAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "optimumAmount", $$v)
            },
            expression: "scope.row.optimumAmount"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.max'),
      "min-width": "8%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          key: _vm.rowUpdateKey,
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.maxAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "maxAmount", $$v)
            },
            expression: "scope.row.maxAmount"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    class: [_vm.status.class]
  }, [_vm._v(_vm._s(_vm.status.message))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "prop": "om61SettingsValid"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.om61SettingsValid),
      callback: function($$v) {
        _vm.$set(_vm.form, "om61SettingsValid", $$v)
      },
      expression: "form.om61SettingsValid"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7139b446!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/om61inventorypanel/src/om61inventorypanel.vue
// module id = 508
// module chunks = 36